import { render } from "./RoutingListDetail.vue?vue&type=template&id=1b35b640"
import script from "./RoutingListDetail.vue?vue&type=script&lang=js"
export * from "./RoutingListDetail.vue?vue&type=script&lang=js"

import "./RoutingListDetail.vue?vue&type=style&index=0&id=1b35b640&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__